module.exports = __webpack_public_path__ + "static/media/mc-embed.ac254bff.txt";